import { Component, Input, OnInit } from '@angular/core';
import { AnswerOption, Evaluation, Question } from '../../interfaces/questionInterface';
import { QuestionComponent } from '../question/question.component';
import { AnswerComponent } from '../answer/answer.component';
import { ActivatedRoute } from '@angular/router';
import { QuestionService } from '../../services/question.service';
import { TestComponent } from '../../components/test/test.component';

@Component({
    selector: 'app-individual-question',
    imports: [QuestionComponent, AnswerComponent, TestComponent],
    templateUrl: './individual-question.component.html',
    styleUrl: './individual-question.component.scss'
})
export class IndividualQuestionComponent implements OnInit {
  question?: Question;
  answers: string[] = [];
  evaluation?: Evaluation;
  showAnswer?: boolean = false;
  shuffled?: boolean = false;

  orderSeed = 'public'; // used as the default when no other 'order' is given in the URL

  @Input()
  private questionId!: string;

  constructor(private questionService: QuestionService, private route: ActivatedRoute) { }

  async ngOnInit() {
    const show_answer = this.route.snapshot.queryParamMap.get('show_answer');
    this.orderSeed = this.route.snapshot.queryParamMap.get('order') || this.orderSeed;

    await this.loadQuestion(this.questionId);

    if (show_answer && show_answer.toLowerCase() === 'true') {
      this.showAnswer = true;
      this.evaluation = this.question?.expand.answer_options?.map(a => {
        const e = a as AnswerOption & { hit: boolean; }
        e.hit = true;
        return e;
      })
    }
  }

  async loadQuestion(id: string) {
    this.question = await this.questionService.getOneQuestion(id);
  }

  handleAnswersSelected(answers: string[]) {
    this.answers = answers;
    this.shuffled = true;
  }

  submitAnswer() {
    this.evaluation = this.question?.expand.answer_options?.map(a => {
      const e = a as AnswerOption & { hit: boolean; }
      e.hit = (a.correct && this.answers.includes(a.id)) || (!a.correct && !this.answers.includes(a.id));
      return e;
    })
  }

  reset() {
    this.shuffled = true;
    this.answers = [];
    this.evaluation = undefined;
  }
}
